import React from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './ServicosPage.css';

const ServicosPage = () => {
  return (
    <>
      <Header />
      
      {/* Hero Banner */}
      <section className="servicios-hero">
        <div className="servicios-hero-content">
          <h1>NOSSOS SERVIÇOS</h1>
          <p>
            Na Veridicus, nossa equipe de especialistas está pronta para atender às suas demandas com eficiência, transparência e compromisso com a verdade.
          </p>
          <p>
            Atuamos em todos os estados brasileiros, por meio de uma rede de parceiros estrategicamente distribuídos, garantindo agilidade e precisão em cada
            processo. Confira abaixo nossos principais serviços.
          </p>
        </div>
      </section>
      
      {/* Curved Divider */}
      <div className="curved-divider gray-to-white">
        <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" className="shape-fill"></path>
        </svg>
      </div>
      
      {/* Main Services Introduction */}
      <section className="servicios-intro">
        <div className="servicios-intro-content">
          <h2>Soluções para Juntas Comerciais</h2>
          <p>
            Na Veridicus, oferecemos uma gama completa de serviços relacionados a registros em Juntas Comerciais. 
            Nossa equipe de especialistas está preparada para atender todas as suas necessidades com eficiência, 
            transparência e compromisso com a verdade.
          </p>
          <p>
            Atuamos em todos os estados brasileiros, com uma rede de parceiros estrategicamente posicionados 
            para garantir agilidade em todos os processos. Confira abaixo nossos principais serviços:
          </p>
        </div>
      </section>
      
      {/* Detailed Services */}
      <section className="servicios-detailed" style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/images/SolucoesJunta.jpg)`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}>
        <div className="servicios-grid-container">
          <h2 className="servicios-grid-title">Soluções para Juntas Comerciais</h2>
          <div className="servicios-grid">
            {/* Service 1 - Backoffice */}
            <Link to="/servicos/backoffice" className="servicio-card">
              <h3>BACKOFFICE</h3>
            </Link>
            
            {/* Service 2 - Terceirização de Processos */}
            <Link to="/servicos/terceirizacao" className="servicio-card">
              <h3>TERCEIRIZAÇÃO DE PROCESSOS</h3>
            </Link>
            
            {/* Service 3 - Apoio a Escritórios */}
            <Link to="/servicos/apoio-juridico" className="servicio-card">
              <h3>APOIO A ESCRITÓRIOS E DEPARTAMENTOS JURÍDICOS</h3>
            </Link>
            
            {/* Service 4 - Consultoria */}
            <Link to="/servicos/consultoria" className="servicio-card">
              <h3>CONSULTORIA EM REGULARIZAÇÕES E COMPLIANCE</h3>
            </Link>
            
            {/* Service 5 - Presença Estratégica */}
            <Link to="/servicos/presenca-estrategica" className="servicio-card">
              <h3>PRESENÇA ESTRATÉGIA EM ÓRGÃOS E CONSELHOS</h3>
            </Link>
            
            {/* Service 6 - Gestão de Cadastros */}
            <Link to="/servicos/gestao-cadastros" className="servicio-card">
              <h3>GESTÃO DE CADASTROS FISCAIS E SOCIETÁRIOS</h3>
            </Link>
            
            {/* Service 7 - Emissão de Alvarás */}
            <Link to="/servicos/alvaras" className="servicio-card">
              <h3>EMISSÃO DE ALVARÁS E AUTORIZAÇÕES</h3>
            </Link>
            
            {/* Service 8 - Documentos Jurídicos */}
            <Link to="/servicos/documentos" className="servicio-card">
              <h3>CRIAÇÃO E GESTÃO DE DOCUMENTOS JURÍDICOS</h3>
            </Link>
            
            {/* Service 9 - Registro de Marca */}
            <Link to="/servicos/registro-marca" className="servicio-card">
              <h3>REGISTRO DE MARCA NO INPI</h3>
            </Link>
          </div>
        </div>
      </section>
      
      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>PRECISA DE SERVIÇOS PERSONALIZADOS?</h2>
          <p className="cta-subtitle">
            Além dos serviços listados, a Veridicus está preparada para atender demandas específicas relacionadas a registros comerciais.
          </p>
          <p className="cta-text">
            Entre em contato conosco para discutir suas necessidades
          </p>
          <Link to="/fale-conosco" className="cta-button">
            Fale Conosco
          </Link>
        </div>
        <div className="cta-angle"></div>
      </section>
      
      <Footer />
    </>
  );
};

export default ServicosPage;